import React, { useMemo } from 'react';
import {
  type SandboxPayload,
} from '@interactive-room';
import { ExploraLiveEditor } from '../live/ExploraLiveEditor';
import { InflationLiveEditor } from '../live/InflationLiveEditor';
import { emptySandboxPayload } from '../emptyPayloads';
import {
  getActivityDraft,
} from '../activityStorage';

import type { StudioLiveEditorProps } from '../types/editor.types';

interface SandboxBuilderProps extends StudioLiveEditorProps {}

function InflationBuilderForm(props: SandboxBuilderProps) {
  return <InflationLiveEditor {...props} />;
}

export function SandboxBuilder(props: SandboxBuilderProps) {
  const { draftId } = props;
  const initial = useMemo(
    () => (draftId ? getActivityDraft(draftId)?.payload : null) as SandboxPayload | null,
    [draftId],
  );

  if (initial?.variant === 'inflation-market') {
    return <InflationBuilderForm draftId={draftId} onSaved={props.onSaved} />;
  }

  return <ExploraLiveEditor {...props} />;
}
